// extracted by mini-css-extract-plugin
export default {"img":"SuggestionBird_img__BfJNZ","container":"SuggestionBird_container__0LEgN"};